import { useState } from "react";

import { DesktopContent } from "./DesktopContent";
import { MobileContent } from "./MobileContent";

import { JobCardType } from ".";

import { Job, UserJobPreferences } from "@otta/search/schema";
import { useMedia } from "@otta/search/providers/media";
import { Loading } from "@otta/search/components/Loading";

interface JobContentProps {
  job: Job.Fragment;
  user?: UserJobPreferences.CurrentUser;
  type: JobCardType;
  publicJob?: boolean;
  toggleKeyboardShortcuts?: (enable: boolean) => void;
}

export function JobContent({
  job,
  user,
  type,
  toggleKeyboardShortcuts,
}: JobContentProps): React.ReactElement | null {
  const desktop = useMedia({ from: "tablet" });
  const [otherJobsExpanded, setOtherJobsExpanded] = useState(false);
  const handleExpandOtherJobs =
    type !== JobCardType.dashboard
      ? () => setOtherJobsExpanded(true)
      : undefined;

  if (desktop.loading) {
    return <Loading />;
  }

  if (desktop.matches) {
    return (
      <DesktopContent
        job={job}
        user={user}
        otherJobsExpanded={otherJobsExpanded}
        expandOtherJobs={handleExpandOtherJobs}
        toggleKeyboardShortcuts={toggleKeyboardShortcuts}
      />
    );
  }
  return (
    <MobileContent
      job={job}
      user={user}
      otherJobsExpanded={otherJobsExpanded}
      expandOtherJobs={handleExpandOtherJobs}
    />
  );
}
